import React, { useState } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PageviewIcon from '@material-ui/icons/Pageview';
import UmslagToPdf from "./UmslagToPdf";


const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing()
  }
}));

export default function UmslagPreview(props) {
  const classes = useStyles();
  const { kjosandi, activeKosning } = props;
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
      >
        <PageviewIcon className={classes.icon} />
        Skoða umslag
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="max-width-dialog-title">
          Umslag fyrir {kjosandi.nafn}
        </DialogTitle>
        <DialogContent>
          <PDFViewer width="100%" height="600px">
            <UmslagToPdf kjosandi={kjosandi} activeKosning={activeKosning} />
          </PDFViewer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Loka
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}